<template>
  <div 
    v-if="!loading && events.length > 0 && cookieConsent"
    v-effect="{ currentTime, viewPort }"
    v-scroll-behaviour
    @mouseover="$_mouseOver"
    @mouseleave="$_mouseLeave"
    :class="{'--scrolled': isScrolled, '--nav-up': navTop && isNavUp, '--mobileState': viewPort }"
    class="news-popup">
    <div class="news-popup__bar"></div>
    <p class="news-popup__label" v-html="events[0].fields.introduction"/>
    <div class="news-popup__content" v-html="description"/>
    <p class="news-popup__date" v-html="events[0].fields.duration"/>
    <svg class="closePopUp" @click="$_closePopUp" width="10px" height="9px" viewBox="0 0 10 9" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="square">
        <g id="pop-up-eventi-3" transform="translate(-435.000000, -666.000000)" stroke="#000000">
            <g id="Group-4" transform="translate(55.000000, 656.000000)">
                <g id="ic-close" transform="translate(380.000000, 10.000000)">
                    <g id="ic">
                        <path d="M4.8211826,4.8211826 L0.642824347,0.642824347 L4.8211826,4.8211826 L8.99954085,0.642824347 L4.8211826,4.8211826 Z M4.8211826,4.8211826 L8.9881396,8.9881396 L4.8211826,4.8211826 L0.654225596,8.9881396 L4.8211826,4.8211826 Z" id="Combined-Shape" fill-rule="nonzero"></path>
                    </g>
                </g>
            </g>
        </g>
      </g>
    </svg>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import { documentToHtmlString } from '@contentful/rich-text-html-renderer'
import { TweenLite } from 'gsap/TweenLite'

export default {
  name: 'news-popup',
  data: () => ({
    loading: true,
    currentTime: 0,
    isHover: false,
    scrollY: 0,
    oldScrollY: 0,
    navTop: false,
  }),
  props: {
    // true means that we are in a small or medium
    viewPort: {
      type: Boolean,
      required: true
    },
    cookieConsent: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters('contentful', [
      'events'
    ]),
    description: {
      get () {
        return (!this.loading && this.events.length > 0) ?
        documentToHtmlString(this.events[0].fields.description) :
        ''
      }
    },
    isScrolled: {
      get () {
        return this.scrollY > window.innerHeight + this.menuHeight
      }
    },
    isNavUp: {
      get () {
        return this.scrollY > this.menuHeight
      }
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    ...mapActions('contentful', [
      'loadEvents'
    ]),
    async loadData () {
      this.loading = true
      try {
        await this.loadEvents()
        this.loading = false
      } catch (e) {
        // TODO sentry
      }
    },
    $_mouseOver () {
      this.isHover = true 
    },
    $_mouseLeave () {
      this.isHover = false
    },
    $_closePopUp () {
      this.currentTime = 12
    },
    showPopUp () {
      alert('chow it')
    }
  },
  directives: {
    'effect': {
      inserted (el, binding, vnode) {
        const { viewPort } = binding.value
        // console.log(viewPort)
        if (viewPort) {
          // mobile
          TweenLite.to(el, 1, { ease: Power1.easeOut, y: '80px', opacity: 1, onComplete: () => {
            setInterval(() => {
              if (vnode.context.$data.isHover) return
              vnode.context.$data.currentTime += 1
            }, 500)
          }})
        }
        else {
          // desktop
          TweenLite.to(el, 1, { ease: Power1.easeOut, y: '-32px', opacity: 1, onComplete: () => {
            setInterval(() => {
              if (vnode.context.$data.isHover) return
              vnode.context.$data.currentTime += 1
            }, 500)
          }})
        }
      },
      componentUpdated (el, binding, vnode, oldVnode) {
        const { viewPort, currentTime } = binding.value
        const oldViewPort = binding.oldValue.viewPort
        TweenLite.to(el.querySelector('.news-popup__bar'), 1, {width: currentTime * 10 + '%'})
        if (currentTime === 12) {
          if (viewPort) TweenLite.to(el, 1, { ease: Power1.easeOut, y: '-100%', opacity: 0})
          else TweenLite.to(el, 1, { ease: Power1.easeOut, y: '100%', opacity: 0})
        }
        if (oldViewPort !== viewPort) el.style.visibility = 'hidden'
      }
    },
    'scroll-behaviour': {
      bind (el, binding, vnode, oldVnode) {
        window.addEventListener('scroll', (e) => {
          vnode.context.scrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
          vnode.context.navTop = vnode.context.scrollY > vnode.context.oldScrollY

          vnode.context.oldScrollY = vnode.context.scrollY
          vnode.context.menuHeight = 81
        }, { passive: true })
      }
    }
  }
}
</script>

<style lang="scss">
  @import "./news-popup.scss";
</style>
  